import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translator } from 'mage-i18n';

import { getStakeholdersWithUploadedDocuments } from '@/flow/configs/selectors';
import { getBusinessDocuments } from '@/selectors/merchant';

import SummarySection from '../SummarySection';
import { BusinessDocuments } from './BusinessDocuments';
import { StakeholderDocuments } from './StakeholderDocuments';

export const T_PREFIX = 'products-fe.containers.application_summary.documentsCard';

const _DocumentsSummary = ({
  businessDocuments = [],
  region,
  stakeholdersWithDocuments = [],
  t,
  onEdit = null,
}) => (
  <SummarySection title={t(`${T_PREFIX}.title`)} onEdit={onEdit}>
    <BusinessDocuments t={t} documents={businessDocuments} />
    <StakeholderDocuments
      region={region}
      stakeholdersWithDocuments={stakeholdersWithDocuments}
      t={t}
    />
  </SummarySection>
);

_DocumentsSummary.propTypes = {
  region: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  businessDocuments: PropTypes.array,
  stakeholdersWithDocuments: PropTypes.array,
  onEdit: PropTypes.func,
};

export const DocumentsSummary = connect(state => ({
  businessDocuments: getBusinessDocuments(state),
  stakeholdersWithDocuments: getStakeholdersWithUploadedDocuments(state),
  t: translator(state),
}))(_DocumentsSummary);
